<template>
    <div class="wrapper wrapper-content animated fadeInRight">
        <el-form :model="detailInfo" ref="detailInfo" label-width="0px" class="demo-dynamic form-horizontal detailPage">
            <div type="border-card">
                <div class="panel-body">
                    <div class="ibox-content">
                        <div class="form-group">
                            <label class="col-sm-2 control-label">
                                Reward Name
                            </label>
                            <div class="col-sm-10">
                                <el-form-item prop="giftName" :rules="{
                                    required: false, message: $t('message.required'), trigger: 'change'
                                }">
                                    <el-input disabled v-model="detailInfo.giftName" show-word-limit></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-2 control-label">
                                Redemption Member No.
                            </label>
                            <div class="col-sm-10">
                                <el-form-item prop="memberNo">
                                    <el-input disabled v-model="detailInfo.memberNo" show-word-limit></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-2 control-label">
                                Quantity
                            </label>
                            <div class="col-sm-10">
                                <el-form-item prop="qty">
                                    <el-input-number v-model="detailInfo.qty" disabled controls-position="right"
                                        :min="0"></el-input-number>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-2 control-label">
                                Total J Coins
                            </label>
                            <div class="col-sm-10">
                                <el-form-item prop="totalStamp">
                                    <el-input-number v-model="detailInfo.totalStamp" disabled controls-position="right"
                                        :min="0"></el-input-number>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-2 control-label">
                                Request Timestamp
                            </label>
                            <div class="col-sm-10">
                                <el-form-item prop="createdAt" :rules="{
                                    required: false, message: $t('message.required'), trigger: 'change'
                                }">
                                    <el-input disabled v-model="detailInfo.createdAt" show-word-limit></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-2 control-label">
                                Pickup Store Name
                            </label>
                            <div class="col-sm-10">
                                <el-form-item prop="giftStoreName" :rules="{
                                    required: false, message: $t('message.required'), trigger: 'change'
                                }">
                                    <el-input disabled v-model="detailInfo.giftStoreName" show-word-limit></el-input>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-sm-2 control-label">
                                Pickup Address
                            </label>
                            <div class="col-sm-10">
                                <el-form-item prop="pickupAddress" :rules="{
                                    required: false, message: $t('message.required'), trigger: 'change'
                                }">
                                    <el-input disabled v-model="detailInfo.pickupAddress" show-word-limit></el-input>
                                </el-form-item>
                            </div>
                        </div>

                        <div class="form-group">
                            <label class="col-sm-2 control-label">
                                Status
                            </label>
                            <div class="col-sm-4">
                                <el-form-item prop="status" :rules="{
                                    required: false, message: $t('message.required'), trigger: 'change'
                                }">
                                    <el-select :disabled="detailInfo.status != 1" v-model="detailInfo.status"
                                        v-bind:placeholder='$t("message.PleaseSelect")'>
                                        <el-option :disabled="item.value == 4" v-for="item in statusMap" :key="item.value" :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </div>
                        </div>
                        <div class="hr-line-dashed"></div>
                        <div class="form-group">
                            <label class="col-sm-2 control-label"> My Notes </label>
                            <div class="col-sm-10">
                                <el-form-item prop="sloNote">
                                    <el-input type="textarea" :rows="3" v-model="detailInfo.note" :name="'sloNote'" />
                                </el-form-item>
                            </div>
                        </div>
                        <div class="form-group">
                            <div class="col-sm-12">
                                <div class="pull-right">
                                    <el-button type="primary" @click="submit()" v-if="$route.query.id
                                        ">Save</el-button>
                                    <el-button @click="showWarning()">{{
                                        $t("message.Cancel")
                                    }}</el-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>
<script>
import config from "../config";
export default {
    mixins: [config.globalMixin],
    data() {
        return {
            detailInfo: {
                giftId: null,
                inventory: 0,
                remark: "",
                type: 1,
                giftStoreName: '',
                note: "",

                id: null,
                giftName: "",
                requestId: null,
                memberNo: null,
            },
        };
    },
    computed: {
        _language() {
            return this.$store.state.userInfo.langCode;
        },
        statusMap() {
            return [
                { value: 0, label: "Open" },
                { value: 1, label: "Ready" },
                { value: 2, label: "Cancelled" },
                {
                    label: "Expired",
                    value: 3
                },
                {
                    label: "InTransit",
                    value: 4
                }
            ]
        }
    },
    watch: {
        detailInfo: {
            handler: function () {
                this.$store.state.edit = true;
            },
            deep: true
        }
    },
    created() {
        this.init();
    },
    mounted() { },
    methods: {
        async init() {
            let id = this.$route.query.id;
            var that = this;
            if (id) {
                let obj = this.getAuthObj();
                obj.id = id;
                obj.apiUrl = this.apiConfig.giftRequestDetail;
                let data = await this.$store.dispatch("apiEvent", obj);
                if (data == "000104") {
                    this.timeoutEvent();
                    return;
                }
                if (!data) return;
                this.$set(this, "detailInfo", data.data.result);
                setTimeout(function () {
                    that.$store.state.edit = false;
                }, 500);
            } else {
                setTimeout(function () {
                    that.$store.state.edit = false;
                }, 500);
            }
        },
        showWarning(type) {
            var that = this;
            if (!type) {
                that.$router.go(-1);
            } else if (type == 1) {
                this.$store.commit("setwarning", {
                    string: this.$i18n.t("message.deleteContent"),
                    boolean: true,
                    button: [
                        {
                            name: this.$i18n.t("message.Confirm"),
                            callBack: function () {
                                that.$store.commit("setwarning", {
                                    string: "",
                                    boolean: false
                                });
                                that.callDelete();
                            }
                        },
                        {
                            name: this.$i18n.t("message.Cancel"),
                            callBack: function () {
                                that.$store.commit("setwarning", {
                                    string: "",
                                    boolean: false
                                });
                            }
                        }
                    ]
                });
            }
        },
        async submit() {
            try {
                let obj = this.getAuthObj();
                obj.note = this.detailInfo.note
                obj.id = this.detailInfo.id
                var data;
                obj.apiUrl = this.apiConfig.giftRequestUpdate;
                data = await this.$store.dispatch("apiEvent", obj);
                if (data == "000104") {
                    this.timeoutEvent();
                    return;
                }
                if (!data) return;
                if (data.data.status_code === "0") {
                    this.$store.state.edit = false;
                    this.$router.go(-1);
                }
            } catch (err) { }
        },
        Delete() {
            this.showWarning(1);
        },
        async callDelete() {
        },
    }
};
</script>
  